<template>
  <div class="report">
    <BasicTable
      :tableColumn="tableColumn"
      :tableData="taskPlanCompletedList"
      :showAddButton="false"
      :showSearch="true"
      :hasAddBtn="false"
      tableTitle="飞行报告"
      ref="taskPlanCompletedList"
      :current="currentExcuted"
      :total="totalExcuted"
      :size="sizeExcuted"
      @search-item="searchItem"
      @size-change="handleSizeChange_excuted"
      @current-change="handleCurrentChange_excuted"
    >
      <!-- 自定义内容 -->
      <template #customCol>
        <el-table-column prop="type" label="任务类型" align="center" min-width="60" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.type == 0">观光</span>
            <span v-else-if="scope.row.type == 1">巡检</span>
            <span v-else-if="scope.row.type == 2">物流</span>
            <span v-else-if="scope.row.type == 3">应急</span>
          </template>
        </el-table-column>
<!--        <el-table-column-->
<!--          prop="status"-->
<!--          label="状态"-->
<!--          align="center"-->
<!--          min-width="60"-->
<!--          :show-overflow-tooltip="true"-->
<!--        >-->
<!--          <template slot-scope="scope">-->
<!--            <span v-if="scope.row.status === 3">正在执行</span>-->
<!--            <span v-else-if="scope.row.status === 4">已执行</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <!-- <el-table-column
          prop="planSerial"
          label="活动编号"
          align="center"
          min-width="60"
          :show-overflow-tooltip="true"
        >
        </el-table-column> -->
        <el-table-column
          prop="note"
          label="备注"
          align="center"
          min-width="60"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
      </template>
      <!-- customBtn自定义操作列 -->
      <template #customBtn>
        <el-table-column label="操作" align="center" min-width="40">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 14">
              <el-button @click="showReport(scope.row)" type="text" size="small"
                >报告</el-button
              >
            </span>
          </template>
        </el-table-column>
      </template>
    </BasicTable>

    <BasicForm
      :isStyleApplied="isStyleApplied"
      labelWidth="100px"
      :dialogVisible="clickShowReport"
      dialogTitle="飞行报告"
      dialogType="飞行报告"
      :formModel="reportForm"
      :btnName="btnName"
      @submit="handleDownload"
      @update:dialogVisible="updateDialogVisible"
      :formRules="formRules"
      :btnLoading="btnLoading"
    >
      <!-- <div class="reportRow">
        <el-form-item label="飞行报告详情" prop="report">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 10 }"
            placeholder="请输入内容"
            v-model="reportForm.report"
            :disabled="true"
            maxlength="2000"
          >
          </el-input>
        </el-form-item>
      </div> -->
      <!-- <el-col :span="12">
        <el-form-item label="活动编号" prop="planSerial">
          <el-input
            placeholder="请填写活动编号"
            maxlength="200"
            v-model="reportForm.planSerial"
            :disabled="true"
          >
          </el-input
        ></el-form-item>
      </el-col> -->
  <div style="width: 100%;height: 100%;display: flex;">
    <div style="width: 40%;height: 100%;">
      <el-col :span="12">
        <el-form-item label="飞机序列号" prop="uavSerial">
          <el-input
            placeholder="请填写飞机序列号"
            maxlength="200"
            v-model="reportForm.uavSerial"
            :disabled="true"
          >
          </el-input
        ></el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="飞机型号" prop="uavModel">
          <el-input
            placeholder="请填写飞机型号"
            maxlength="200"
            v-model="reportForm.uavModel"
            :disabled="true"
          >
          </el-input
        ></el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="驾驶员执照号" prop="pilotLicense">
          <el-input
            placeholder="请填写驾驶员执照号"
            maxlength="200"
            v-model="reportForm.pilotLicense"
            :disabled="true"
          >
          </el-input
        ></el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="驾驶员" prop="pilot">
          <el-input
            placeholder="请填写驾驶员名称"
            maxlength="200"
            v-model="reportForm.pilot"
            :disabled="true"
          >
          </el-input
        ></el-form-item>
      </el-col>
      <!--        <el-col :span="12">
          <el-form-item label="运营人编号" prop="operatorNum">
            <el-input
              placeholder="请填写运营人编号"
              maxlength="200"
              v-model="reportForm.operatorNum"
              :disabled="true"
            >
            </el-input
          ></el-form-item>
        </el-col>-->
        <el-col :span="12">
        <el-form-item label="运营人执照号" prop="operatorLicense">
          <el-input
            placeholder="请填写运营人执照号"
            maxlength="200"
            v-model="reportForm.operatorLicense"
            :disabled="true"
          >
          </el-input
        ></el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="运营人名称" prop="operatorName">
          <el-input
            placeholder="请填写运营人名称"
            maxlength="200"
            v-model="reportForm.operatorName"
            :disabled="true"
          >
          </el-input
        ></el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="飞行活动起点" prop="startPointId">
          <el-input
            v-model="reportForm.startPoint.name"
            placeholder="请选择起飞点"
            :disabled="true"
          >
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="飞行活动终点" prop="endPointId">
          <el-input
            v-model="reportForm.endPoint.name"
            placeholder="请选择降落点"
            :disabled="true"
          >
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="飞行航线" prop="routeName">
          <el-input
            v-model="reportForm.routeName"
            placeholder="请选择航线信息"
            :disabled="true"
          >
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="飞行活动类型" prop="type">
            <el-select v-model="reportForm.type" placeholder="请填写飞行活动类型" popper-class="adminHomeSelect" :disabled="true">
              <el-option v-for="type in typeList" :key="type.id" :label="type.name" :value="type.id"></el-option>
            </el-select>
          </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="飞行时间" prop="flightDuration">
          <el-input
            maxlength="200"
            v-model="reportForm.flightDuration"
            :disabled="true"
          >
          </el-input
        ></el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="飞行状态" prop="flightStatus">
          <el-input
            maxlength="200"
            v-model="reportForm.flightStatus"
            :disabled="true"
          >
          </el-input
        ></el-form-item>
      </el-col>


      <el-col :span="24">
        <el-form-item label="总结">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 10 }"
            placeholder="请输入内容"
            v-model="reportForm.desc"
            maxlength="2000"
            :disabled="true"
          >
          </el-input>
        </el-form-item>
      </el-col>
    </div>
   <div style="width: 60%;height: 100%;">
     <div style="width: 95%;height: 100%;margin-left: 20px;padding-top: 4px;">
          <SecondMap
            style="width: 100%; height:100%"
            showType="AirPath"
            :airpointList="airpointList"
            ref="map"
          ></SecondMap>
        </div>
   </div>
  </div>
    </BasicForm>

    <!-- <div class="rightDiv" v-show="isDetail">
      <div
        class="planCirculationTimelineBox"
        v-if="activeAccordionName === 'planCirculationInfo'"
      >
        <div class="planCirculationTimelineBoxTitle">计划流转信息</div>
        <div
          :class="[
            'planCirculationTimelineBoxContent',
            isConfirm ? 'isConfirm' : ''
          ]"
        >
          <el-timeline
            class="planCirculationTimelineBoxContentInfo"
            :reverse="true"
          >
            <el-timeline-item
              placement="top"
              v-for="(planCirculationInfo, index) in planCirculationInfos"
              :class="
                index === planCirculationInfos.length - 1 ? 'fontFFA63E' : ''
              "
              :key="index"
              :icon="
                index === planCirculationInfos.length - 1 ? 'el-icon-check' : ''
              "
              :color="
                index === planCirculationInfos.length - 1 ? '#FFA63E' : '#fff'
              "
              :size="
                index === planCirculationInfos.length - 1 ? 'large' : 'normal'
              "
              :timestamp="planCirculationInfo.timestamp"
            >
              {{ planCirculationInfo.content }}
            </el-timeline-item>
          </el-timeline>
        </div>
        <div class="rightBottomDiv" v-show="!isConfirm">
          <el- class="saveButton" v-show="isDetail" @click="submit('pass')"
            >通过</el-
          >
          <el-button
            class="rejectButton"
            v-show="isDetail"
            @click="submit('reject')"
            >驳回</el-button
          >
        </div>
      </div>
      <div class="goodsListAndNote" v-else>
        <div :class="rightTopDiv">
          <div class="rightMainContainer">
            <div class="rightCommonTitle">
              <div class="title">
                <i class="header-icon el-icon-goods-plan"></i>
                &nbsp;货物列表
              </div>
              <div class="title">货物名称:&nbsp;&nbsp;{{ goodsName }}</div>
            </div>
            <el-table
              :data="goodsList"
              class="goodsList"
              ref="goodsList"
              :height="goodsListHeight"
              :row-style="{ height: '40px' }"
              :cell-style="changeCellStyle"
              :row-class-name="goodsListRowClassName"
              tooltip-effect="light"
            >
              <el-table-column
                label="序号"
                align="center"
                prop="index"
                min-width="60"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="local_id"
                label="货物编号"
                align="center"
                min-width="150"
                :show-overflow-tooltip="true"
              >
              </el-table-column
              ><el-table-column
                label="体积（长*宽*高）/cm"
                align="center"
                min-width="180"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.goods_length }}* {{ scope.row.goods_width }}*
                    {{ scope.row.goods_height }}
                  </span>
                </template></el-table-column
              ><el-table-column
                label="重量/kg"
                align="center"
                min-width="80"
                prop="goods_weight"
                :show-overflow-tooltip="true"
              ></el-table-column
              ><el-table-column
                label="属性"
                min-width="220"
                prop="attributes"
                align="center"
                :show-overflow-tooltip="true"
              ></el-table-column
              ><el-table-column
                label="类型"
                align="center"
                prop="goods_type_name"
                min-width="80"
                :show-overflow-tooltip="true"
              ></el-table-column
              ><el-table-column
                label="包装"
                align="center"
                min-width="100"
                prop="goods_package_name"
                :show-overflow-tooltip="true"
              ></el-table-column
              ><el-table-column
                label="密级"
                align="center"
                min-width="60"
                prop="goods_secrecy_id"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.goods_secrecy_id === 0"
                    >非<span>密</span></span
                  >
                  <span v-else-if="scope.row.goods_secrecy_id === 1"
                    >秘<span>密</span></span
                  >
                  <span v-else-if="scope.row.goods_secrecy_id === 2"
                    >机<span>密</span></span
                  ><span v-else-if="scope.row.goods_secrecy_id === 3"
                    >绝<span>密</span></span
                  >
                </template></el-table-column
              >
            </el-table>
          </div>
        </div>
        <div class="rightCenterDiv">
          <div class="rightCommonTitle">
            <div class="title">
              <i class="header-icon el-icon-remark"></i>&nbsp;审批意见
            </div>
            <div class="separator"></div>
          </div>

          <div class="remarkDiv">
            <div class="historyButton">
              <div
                v-if="!isConfirm"
                :class="!isHistory ? 'remarkClassNow' : 'remarkClassHistory'"
                @click="isHistory = false"
              >
                新增备注
              </div>
              <div
                :class="isHistory ? 'remarkClassNow' : 'remarkClassHistory'"
                @click="isHistory = true"
              >
                历史备注
              </div>
            </div>
            <div v-if="isHistory">
              <div class="historyRemark">
                <span v-for="(item, index) in note" :key="index">
                  {{ item }}<br />
                </span>
              </div>
            </div>
            <div v-else-if="!isConfirm">
              <el-input
                style="height: 220px"
                placeholder="请输入备注(500字内，且不能输入$)"
                @input="change($event)"
                type="textarea"
                maxlength="500"
                v-model="flight.note"
              ></el-input>
            </div>
          </div>
          <div class="relations">
            <el-checkbox-group v-model="relations">
              <el-checkbox
                disabled
                v-for="(item, index) in confirmRelations"
                :key="index"
                :label="item.id"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
        </div>
        <div class="rightBottomDiv" v-show="!isConfirm">
          <el-button
            class="saveButton"
            v-show="isDetail"
            @click="submit('pass')"
          >
            通过</el-button
          >
          <el-button
            class="rejectButton"
            v-show="isDetail"
            @click="submit('reject')"
          >
            驳回</el-button
          >
        </div>
      </div>
    </div> -->
  </div>
</template>

<script type="text/javascript">
// import taskIcon from "../../assets/img/home/task.png";
import minimumer from "../../assets/img/home/minimumer.png";
import secondaryer from "../../assets/img/home/secondaryer.png";
import highester from "../../assets/img/home/highester.png";

import parkingApron1 from "../../assets/img/taskPlan/parkingApron1.png";
import parkingApron1Hover from "../../assets/img/taskPlan/parkingApron1Hover.png";
import parkingApron2 from "../../assets/img/taskPlan/parkingApron2.png";
import parkingApron2Hover from "../../assets/img/taskPlan/parkingApron2Hover.png";

import tooltipOver from "../tools/tooltipOver";
import axios from "axios";
import BasicTable from "../../common/BasicTable.vue";
import BasicForm from "../../common/BasicForm.vue";
import SecondMap from "../../common/SecondMap.vue";

import { deepCopy } from "@/utils/tools.js";
import domtoimage from 'dom-to-image';

export default {
  name: "Report",
   props: {
    isStyleApplied: {
      type: Boolean,
      default: false,
    },
    userInfo:{
      type:Object,
      default:{}
    }
  },
  data() {
    return {
      dataURL:'',
      activeAccordionName: "deliveryTime", //当前打开的手风琴名称
      // 存储 计划流转信息
      planCirculationInfos: [],

      landPoints: [], //起降点
      airlines: [], //航线信息
      rules: {
        landPoint_id: [
          { required: true, message: "请选择起降点~", trigger: "blur" }
        ]
      },

      clickButton: false,
      clickShowReport: false,
      // taskIcon: taskIcon,
      waitApprovalNum: 0,
      approvalNum: 0,
      rejectedNum: 0,

      opacityOfWaitApproval: "opacity: 1;",
      opacityOfApproval: "opacity: 0.4;",
      opacityOfRejected: "opacity: 0.4;",
      openTab: "waitApproval",

      isConfirm: false,
      // 是否是查看详情
      isDetail: false,
      isHistory: false,

      rightTopDiv: "rightTopDiv",
      goodsListHeight: 235,
      history: "history",

      queryForm: {
        FlightApproved: 0, //0为待审批，1为审批通过，-1为驳回
        condition: "",
        currentpage: 1,
        pagesize: 0
      },

      // 飞行报告
      reportForm: {
        // id: "",
        planSerial: "",
        uavSerial: "",
        uavModel: "",
        pilot: "",
        operatorNum: "",
        operatorName: "",
        operatorLicense: "",
        startPoint: {},
        endPoint: {},
        routeName: "",
        type: "",
        flightDuration: "", //飞行时间
        flightStatus: "", //飞行状态
        // startPointId:"",
        // endPointId:"",
        // startTime:"",
        // endTime:"",
        // routeId:"",
        //note:"",
        report: "",
        desc: "",
      },

      priorityClass: "",
      priority: null,

      itemList: [],
      itemCompletedList: [],
      taskPlanList: [],
      taskPlanCompletedList: [],

      goodsName: "", //货物名称
      goodsList: [], //货物列表信息

      openedId: null, //已展开的任务
      flight: {}, // 计划信息
      applyer: {}, //提报人
      auditor: {}, //审核员
      customer_groundstaf: {}, //发货地勤
      destination_groundstaf: {}, //收货地勤
      flyer: {}, //飞手
      security: {}, //保障员
      task_controller: {}, //任务控制
      uav: { uavmodel: {} }, //无人机
      airlink: {}, //链路信息
      starstaypoint: {}, //起始驻点
      endstaypoint: {}, //结束驻点
      note: "",

      replaceStr: "$", //分隔符

      relations: [],
      // 确认关系
      confirmRelations: [
        {
          id: 0,
          label: "空域确认"
        },
        {
          id: 1,
          label: "气象确认"
        },
        {
          id: 2,
          label: "地理确认"
        },
        {
          id: 3,
          label: "电磁确认"
        }
      ],

      parkingApron1: parkingApron1,
      parkingApron1Hover: parkingApron1Hover,
      parkingApron2: parkingApron2,
      parkingApron2Hover: parkingApron2Hover,
      formClass: "",
      flag: false,
      tableColumn: [
        { label: "飞机序列号", prop: "uavSerial" },
        { label: "飞机型号", prop: "uavModel" },
        { label: "驾驶员执照号", prop: "pilotLicense" },
        { label: "驾驶员名称", prop: "pilot" },
        //{ label: "运营人编号", prop: "operatorNum" },
        { label: "运营人执照号", prop: "operatorLicense" },
        { label: "运营人名称", prop: "operatorName" },
        { label: "起飞点", prop: "startPoint" },
        { label: "起飞时间", prop: "startTime" },
        { label: "降落点", prop: "endPoint" },
        { label: "降落时间", prop: "endTime" },
        { label: "航线信息", prop: "routeName" },
        // { label: "任务类型", prop: "type" }
        // { label: "状态", prop: "status" },
        // { label: "活动编号", prop: "planSerial" },
        // { label: "备注", prop: "note" },
      ],
      btnName: "", //表单提交按钮名字
      airpointList: [],
      // 定义表单必填校验
      formRules: [],
      totalExcuted: 0, //已执行计划列表总条数
      currentExcuted: 1, //已执行计划列表当前页数
      sizeExcuted: 18, //已执行计划列表显示几条
      btnLoading: false, //按钮加载状态
      typeList: [
        { id: 0, name: "观光" },
        { id: 1, name: "巡检" },
        { id: 2, name: "物流" },
        { id: 3, name: "应急" },
      ],
      searchKey: '', //模糊搜索关键字
    };
  },
  components: {
    "tooltip-over": tooltipOver,
    BasicTable, //公共表格
    BasicForm, //公共弹框
    SecondMap //公共地图
  },
  methods: {
    // 关闭对话框时获取子组件传过来的状态
    updateDialogVisible(newVal) {
      this.clickShowReport = newVal;
    },
    //分页函数
    handleSizeChange_excuted: function (size) {
      this.sizeExcuted = size;
      this.executedPlan();
    },
    handleCurrentChange_excuted: function (current) {
      this.currentExcuted = current;
      this.executedPlan();
    },
    change(e) {
      this.$forceUpdate();
      // 限制输入特殊字符$
      this.flight.note = e.replace(this.replaceStr, "");
    },
    showMore(val) {
      this.$confirm(val, "", {
        confirmButtonText: "好的",
        customClass: "confirmClass-style",
        iconClass: "",
        confirmButtonClass: "confirm",
        showCancelButton: false
      });
    },
    getUnixTimestamp() {
      const now = new Date();
      return Math.floor(now.getTime() / 1000);
    },
    waitApproval() {
      if (this.openTab !== "waitApproval") {
        this.opacityOfWaitApproval = "opacity: 1;";
        this.opacityOfApproval = "opacity: 0.4;";
        this.opacityOfRejected = "opacity: 0.4;";
        this.openedId = null;
        this.isConfirm = false;
        this.isHistory = false;
        this.isDetail = false;
        this.rightTopDiv = "rightTopDiv";
        this.goodsListHeight = 235;
        this.history = "history";

        this.queryForm.FlightApproved = 0;
        this.getConfirmRelationListByFlightApproved();
      }
      this.openTab = "waitApproval";
    },
    approval() {
      if (this.openTab !== "approval") {
        this.opacityOfWaitApproval = "opacity: 0.4;";
        this.opacityOfApproval = "opacity: 1;";
        this.opacityOfRejected = "opacity: 0.4;";
        this.openedId = null;
        this.isConfirm = true;
        this.isHistory = true;
        this.isDetail = false;
        this.rightTopDiv = "rightConfirmTopDiv";
        this.goodsListHeight = 293;
        this.history = "historyDiv";
        this.queryForm.FlightApproved = 1;
        this.getConfirmRelationListByFlightApproved();
      }
      this.openTab = "approval";
    },
    rejected() {
      if (this.openTab !== "rejected") {
        this.opacityOfWaitApproval = "opacity: 0.4;";
        this.opacityOfApproval = "opacity: 0.4;";
        this.opacityOfRejected = "opacity: 1;";
        this.openedId = null;
        this.isConfirm = true;
        this.isHistory = true;
        this.isDetail = false;
        this.rightTopDiv = "rightConfirmTopDiv";
        this.goodsListHeight = 293;
        this.history = "historyDiv";
        this.queryForm.FlightApproved = -1;
        this.getConfirmRelationListByFlightApproved();
      }
      this.openTab = "rejected";
    },
    getConfirmRelationStaticByFlightApproved() {
      this.getRequest(
        "/uav-task-server/confirmrelation/getConfirmRelationStaticByFlightApproved.do"
      ).then(res => {
        let oData = res.data;
        if (oData.code == 0) {
          let data = oData.data;
          if (data) {
            this.waitApprovalNum = data.WatingFlightApproved;
            this.approvalNum = data.FlightApproved;
            this.rejectedNum = data.FlightRej;
          } else {
            this.waitApprovalNum = 0;
            this.approvalNum = 0;
            this.rejectedNum = 0;
          }
        } else if (oData.code != 401) {
          // let tips = "<i class='el-icon-warn-tip'></i>啊哦,计划统计获取失败~";
          // this.$confirm(tips, "提示", {
          //   confirmButtonText: "好的",
          //   customClass: "confirmClass-style",
          //   iconClass: "",
          //   confirmButtonClass: "confirm",
          //   dangerouslyUseHTMLString: true,
          //   showCancelButton: false,
          // });
        }
      });
    },

    // 打开报告详情
    showReport(param) {
      let _this = this
      this.getRequest(
        "/uav-task-server/plandto/queryPlanDtoById?id="+param.id
      ).then(res => {
        let oData = res.data;
        if (oData.code == 0) {
          let data = oData.data;
          if (data) {
            _this.btnName = "下载";
            _this.clickButton = false;
            _this.clickShowReport = true;
            _this.reportForm = data;
            console.log( _this.reportForm.startPonit)
            _this.airpointList = data.airpointList;
            // console.log("报告", param);
            _this.reportForm.flightDuration = `${data.startTime} -- ${data.endTime}`;
            _this.reportForm.flightStatus = `状态为已执行飞行活动。本次飞行活动圆满结束。`;
            // 映射任务类型 暂且默认为物流
            const taskTypes = ['观光', '巡检', '物流','应急'];
            const taskType = taskTypes[param.type] || '物流';
            // this.reportForm.report = `活动编号为${param.planSerial}，飞机序列号为${param.uavSerial}，飞机型号为${param.uavModel}的飞行活动，由驾驶员${param.pilot}驾驶，由运营人${param.operatorName}（运营人编号：${param.operatorNum}， 运营人执照号： ${param.operatorLicense}）运营，于从${param.startPoint.name}到${param.endPoint.name}执行${param.type}任务，所选航线为：${param.routeName}，飞行时间从${param.startTime}到${param.endTime}，状态为已执行飞行活动。本次飞行活动圆满结束。`;
            _this.reportForm.desc = `本次飞行活动于${param.startTime}到${param.endTime}，从${data.startPoint.name}到${data.endPoint.name}执行${taskType}任务，由${param.pilot}执飞，气象条件（良好），飞行全程各设备状态(良好)，无事故发生。`;
          }
        } else if (oData.code != 401) {
          // let tips = "<i class='el-icon-warn-tip'></i>啊哦,计划统计获取失败~";
          // this.$confirm(tips, "提示", {
          //   confirmButtonText: "好的",
          //   customClass: "confirmClass-style",
          //   iconClass: "",
          //   confirmButtonClass: "confirm",
          //   dangerouslyUseHTMLString: true,
          //   showCancelButton: false,
          // });
        }
      });
    },
    // 点击下载
    async handleDownload() {
      // 点击进入加载状态
      this.btnLoading = true;
      // 确保 DOM 完全渲染
      await this.$nextTick();
      const mapElement = this.$refs.map.$el;
      // 获取元素实际宽高
      domtoimage.toBlob(mapElement)
        .then( (blob)=> {
          const uid = Date.now();
          const fileName = `screenshot_${uid}.jpg`;
          const formData = new FormData();
          formData.append('file', blob, fileName);
          for (let pair of formData.entries()) {
            this.reportForm.file = pair[1];
          }
          this.downloadFile();
        })
        .catch(function (error) {
          console.error('截图失败:', error);
        });

    },
    formatSubmitData(commonForms) {
      const formData = new FormData();
      // 只处理 'id' 和 'file' 属性
      const keysToInclude = ['id', 'file'];
      for (const key of keysToInclude) {
        const element = commonForms[key];
        if (element != null && (element + "").trim().length > 0) {
          formData.append(key, element);
        }
      }
      return formData;
    },

    /**
     * 下载文件 downloadFile
     * @param url 文件路径
     * @param filename 文件名
     * @param id 文件的唯一标识符
     * @param file 图片
     */
    downloadFile() {
      const url = "/uav-task-server/download/getFlightReport";
      const multiData = this.formatSubmitData(deepCopy(this.reportForm));

      axios({
        method: "post",
        url: url,
        data: multiData, //传递id 和 图片文件
        responseType: "blob"
      })
        .then(response => {
          this.btnLoading = false;
          this.clickShowReport = false;
          const contentDisposition = response.headers["content-disposition"];
          let filename = contentDisposition.split("filename=")[1];
          if (filename) {
            filename = decodeURIComponent(filename.trim().replace(/"/g, ""));
            filename = filename.replace(/[\/\\:*?"<>|]/g, "_"); // 替换非法字符
          } else {
            filename = "flight-report.docx"; // 设置默认文件名
          }
          const blob = new Blob([response.data], {
            type:
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(link.href);
        })
        .catch(error => {
          this.btnLoading = false;
          this.clickShowReport = false;

          console.error("下载文件出错:", error);
          throw new Error("下载文件出错");
        });
    },

    sleep(param) {
      this.$message({
        message: "休息一下吧"
      });
    },

    executedPlan() {
      this.getRequest(`/uav-task-server/plandto/queryPlan?status=14&currentpage=${this.currentExcuted}&pagesize=${this.sizeExcuted}&keyWord=${this.searchKey}`)
      .then(res => {
          let oData = res.data;
          if (0 == oData.code) {
            if (oData.data) {
              this.taskPlanCompletedList = oData.data.list;
              this.totalExcuted = oData.data.total;
              this.currentExcuted = oData.data.pageNum;
            } else {
              this.taskPlanCompletedList = [];
            }
          }
        }
      );
    },

    clickTaskPlanRow(row) {
      this.activeAccordionName = "deliveryTime"; // 点击表格内计划信息时 重置 折叠面板
      this.openedId = row.id;
      this.setRelations(row);
      this.queryFlight(row.flight_id);
      this.isDetail = true;
      this.$refs.taskPlanList.toggleRowSelection(row);
    },
    setRelations(row) {
      let relations = [];
      let airspace_confirm = row.airspace_confirm;
      if (1 === airspace_confirm) {
        relations.push(0);
      }
      let meteorology_confirm = row.meteorology_confirm;
      if (1 === meteorology_confirm) {
        relations.push(1);
      }
      let geography_confirm = row.geography_confirm;
      if (1 === geography_confirm) {
        relations.push(2);
      }
      let electromagnetism_confirm = row.electromagnetism_confirm;
      if (1 === electromagnetism_confirm) {
        relations.push(3);
      }
      this.relations = relations;
    },
    //获取起降点信息
    queryAllCPoint() {
      let vue = this;
      this.getRequest(
        "/uav-task-server/cpoint/queryAllCPoint?pagesize=700&currentpage=1"
      )
        .then(res => {
          let oData = res.data;
          if (0 == oData.code) {
            let pointData = oData.data;
            let pointDataList = pointData.list;

            //pointDataList= pointDataList.find(x.type===2);
            let pointDataItemList = [];
            for (let i = 0, len = pointDataList.length; i < len; i++) {
              //console.log(planData[i]);
              if (2 === pointDataList[i].type) {
                pointDataItemList.push(pointDataList[i]);
              }
            }
            console.log(pointDataItemList);
            pointDataList = pointDataItemList;
            if (pointDataList) {
              this.landPoints = pointDataList;
            } else {
              this.landPoints = [];
            }
          } else if (oData.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch(error => {});
    },
    //获取航线信息
    queryAllCline() {
      let vue = this;
      this.getRequest(
        "/uav-task-server/cairline/queryAllCAirline?pagesize=500&currentpage=1"
      )
        .then(res => {
          let oData = res.data;
          if (0 == oData.code) {
            let lineData = oData.data;
            let lineDataList = lineData.list;
            //console.log(lineDataList);
            if (lineDataList) {
              this.airlines = lineDataList;
            } else {
              this.airlines = [];
            }
          } else if (oData.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch(error => {});
    },
    // 根据id获取活动信息
    queryFlight(id) {
      this.getRequest("/uav-task-server/flight/queryFlight.do?id=" + id).then(
        res => {
          let oData = res.data;
          if (oData.code == 200) {
            let data = oData.data;
            if (data) {
              if (data.flight) {
                // 获取当前id活动的 活动流转信息
                this.planCirculationInfos = data.flight.plan_transfer_note
                  ? JSON.parse(data.flight.plan_transfer_note)
                  : [];

                this.flight = data.flight;
                if (!this.isEmptyStr(this.flight.task_coordinate_waypoints)) {
                  const points = this.flight.task_coordinate_waypoints.split(
                    ";"
                  );
                  this.flight.point_count = points.length;
                } else {
                  this.flight.point_count = 0;
                }
              } else {
                this.flight = {};
              }
              let note = this.flight.note;
              if (note) {
                let notes = note.split(this.replaceStr);
                if (notes && notes.length > 0) {
                  let notee = [];
                  notes.forEach(item => {
                    if (item) {
                      notee.push(item);
                    }
                  });
                  this.note = notee;
                } else {
                  this.note = "";
                }
              } else {
                this.note = "";
              }
              this.flight.note = "";
              if (data.applyer) {
                this.applyer = data.applyer;
              } else {
                this.applyer = {};
              }
              if (data.auditor) {
                this.auditor = data.auditor;
              } else {
                this.auditor = {};
              }
              if (data.customer_groundstaf) {
                this.customer_groundstaf = data.customer_groundstaf;
              } else {
                this.customer_groundstaf = {};
              }
              if (data.destination_groundstaf) {
                this.destination_groundstaf = data.destination_groundstaf;
              } else {
                this.destination_groundstaf = {};
              }
              if (data.flyer) {
                this.flyer = data.flyer;
              } else {
                this.flyer = {};
              }
              if (data.lsgoods) {
                this.goodsList = data.lsgoods;
              } else {
                this.goodsList = [];
              }
              if (data.security) {
                this.security = data.security;
              } else {
                this.security = {};
              }
              if (data.task_controller) {
                this.task_controller = data.task_controller;
              } else {
                this.task_controller = {};
              }
              if (data.airlink) {
                this.airlink = data.airlink;
              } else {
                this.airlink = {};
              }
              if (data.starstaypoint) {
                this.starstaypoint = data.starstaypoint;
              } else {
                this.starstaypoint = {};
              }
              if (data.endstaypoint) {
                this.endstaypoint = data.endstaypoint;
              } else {
                this.endstaypoint = {};
              }
              if (data.uav) {
                this.uav = data.uav;
              } else {
                this.uav = { uavmodel: {} };
              }
              this.choosePriority();
              this.dealDataAfterGetDetail();
            }
          } else if (oData.code != 401) {
            // let tips = "<i class='el-icon-warn-tip'></i>啊哦,活动信息获取失败~";
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "confirmClass-style",
            //   iconClass: "",
            //   confirmButtonClass: "confirm",
            //   dangerouslyUseHTMLString: true,
            //   showCancelButton: false,
            // });
          }
        }
      );
    },
    choosePriority() {
      let priority = this.flight.priority;
      if (1 === priority) {
        this.priority = minimumer;
        this.priorityClass = "minimumer";
      } else if (2 === priority) {
        this.priority = secondaryer;
        this.priorityClass = "secondaryer";
      } else if (3 === priority) {
        this.priority = highester;
        this.priorityClass = "highester";
      }
    },
    // 获取详情后 数据处理
    dealDataAfterGetDetail() {
      // 设置货物列表信息 start
      let goodsList = this.goodsList;
      if (goodsList && goodsList.length > 0) {
        let _this = this;
        this.goodsName = goodsList[0].goods_name;
        goodsList.forEach(function(goods, index) {
          let attributes = [];
          let goods_attribute_id = goods.goods_attribute_id;
          if (goods_attribute_id && 1 === Number(goods_attribute_id)) {
            attributes.push("易碎性");
          }
          let goods_explosible_id = goods.goods_explosible_id;
          if (goods_explosible_id && 1 === Number(goods_explosible_id)) {
            attributes.push("易爆性");
          }
          let goods_inflammable_id = goods.goods_inflammable_id;
          if (goods_inflammable_id && 1 === Number(goods_inflammable_id)) {
            attributes.push("易燃性");
          }
          let goods_cautery_id = goods.goods_cautery_id;
          if (goods_cautery_id && 1 === Number(goods_cautery_id)) {
            attributes.push("腐蚀性");
          }
          let attributesStr = "";
          for (let i = 0, len = attributes.length; i < len; i++) {
            if (i === len - 1) {
              attributesStr += attributes[i];
            } else {
              attributesStr += attributes[i] + ",";
            }
          }
          _this.$set(goods, "attributes", attributesStr); //触发更新视图
        });
        _this.goodsList = goodsList;
      } else {
        this.goodsList = [];
      }
    },
    submit(type) {
      if ("pass" === type) {
        this.flight.flight_status = 40;
        this.updateConfirmRelationByFlightApproved();
      } else {
        let note = this.flight.note;
        if (note) {
          this.flight.flight_status = 31;
          this.updateConfirmRelationByFlightApproved();
        } else {
          let tips = "<i class='el-icon-warn-tip'></i>驳回时,需要填写备注哦~";
          this.$confirm(tips, "", {
            confirmButtonText: "好的",
            customClass: "confirmClass-style",
            iconClass: "",
            confirmButtonClass: "confirm",
            dangerouslyUseHTMLString: true,
            showCancelButton: false
          });
        }
      }
    },
    // 按活动审批的驳回和确认操作
    updateConfirmRelationByFlightApproved() {
      let tips = "<i class='el-icon-warn-tip'></i>确定提交该活动?";
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "confirmClass-style",
        iconClass: "",
        confirmButtonClass: "confirm",
        dangerouslyUseHTMLString: true,
        cancelButtonClass: "cancel"
      })
        .then(() => {
          this.flight.id = this.openedId;
          this.postJsonRequest(
            "/uav-task-server/confirmrelation/updateConfirmRelationByFlightApproved.do",
            this.flight
          ).then(res => {
            let oData = res.data;
            if (oData.code === 0) {
              this.isDetail = false;
              this.getConfirmRelationStaticByFlightApproved();
              this.getConfirmRelationListByFlightApproved();
              this.$message({
                message: oData.msg,
                duration: 1000,
                customClass: "message-s",
                iconClass: "el-icon-ok-tip",
                offset: 470,
                onClose: function() {}
              });
            } else if (oData.code != 401) {
              this.$message.error({
                message: oData.msg,
                duration: 1000,
                customClass: "message-warn-s",
                iconClass: "el-icon-warn-tip",
                offset: 470,
                onClose: function () {
                }
              });
            }
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    changeBackground(taskPlanList) {
      if (taskPlanList.status == 0) {
        return "taskTableRedBackground";
      } else if (taskPlanList.status == 1) {
        return "taskTableBlueBackground";
      } else {
        return "taskTable";
      }
    },
    changeCellStyle(row, column, rowIndex, columnIndex) {
      if (row.column.label === "优先级") {
        return "color:#FFA63E;padding: 0;"; //修改的样式
      } else {
        return "color:#FFFFFF;padding: 0;";
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (this.openedId === row.id) {
        return "focusRowStyle";
      }
      return "rowStyle";
    },
    goodsListRowClassName({ row, rowIndex }) {
      row.index = rowIndex + 1;
      return "rowStyle";
    },
    searchItem(val) {
      //模糊搜索
      // console.log(val);
      this.searchKey = val;
      this.executedPlan();
    },
  },
  mounted() {
    this.$nextTick(function() {
      this.executedPlan();
    });
    window.queryTimer = setInterval(this.executedPlan, 8000); //查询已执行数据，8秒轮询一次
  },
  beforeDestroy() {
    if (window.statisicsTimer) {
      clearInterval(window.statisicsTimer);
      window.statisicsTimer = null;
    }
    if (window.queryTimer) {
      clearInterval(window.queryTimer);
      window.queryTimer = null;
    }
  }
};
</script>

<style scoped>
/* .report {
  margin-top: 63px;
} */

>>> .el-form{
  padding: 0 !important;
}
>>> .el-form-item__content {
  margin-left: 120px !important;
  height: 100%;
}
/* >>> .el-form-item__label{
  width: 100px !important;
  text-align: right;
} */
>>>.el-dialog__header {
    /* background-image: url(../../img/common/tableHead.png); */
    /* background-position: 15px 13px;
    background-repeat: no-repeat;
    background-size: 300px 35px; */
    padding: 20px 20px 0px 40px ;
    background: url(../../assets/img/2dmap/pop_bg.png)  no-repeat;
    background-position: 18px 25px;
}
</style>

<!-- <style scoped>
.report {
  margin-top: 63px;
}
.reportRow .el-form-item {
  width: 100%;
}
.el-textarea .el-textarea__inner {
  background: transparent !important;
  border: 1px solid #0083fd !important;
  font-size: inherit !important;
  color: #fff !important;
}
/* border: 1px solid #0083fd; */
.el-select {
  width: 246px;
  height: 32px;
}
.el-select .el-input__suffix {
  right: 55px;
}
.el-date-editor {
  width: 246px !important;
  height: 32px;
  text-align: center;
}
.el-date-editor .el-input__prefix {
  left: 50px;
}
.leftBottomDiv .buttons .buttonClass:last-child {
  margin-right: 0;
}
.planCirculationTimelineBoxContent
  .planCirculationTimelineBoxContentInfo
  .el-timeline-item__content,
.planCirculationTimelineBoxContent
  .planCirculationTimelineBoxContentInfo
  .el-timeline-item__timestamp {
  text-align: left;
  font-size: 14px;
  font-family: ArialMT, AlibabaPuHuiTiR;
  color: #c1c1c1;
}
.planCirculationTimelineBoxContent
  .planCirculationTimelineBoxContentInfo
  .fontFFA63E
  .el-timeline-item__content,
.planCirculationTimelineBoxContent
  .planCirculationTimelineBoxContentInfo
  .fontFFA63E
  .el-timeline-item__timestamp {
  color: #ffa63e;
}
.myinput {
  width: 246px !important;
  height: 320px !important;
}
</style> -->



// WEBPACK FOOTER //
// src/components/home/Report.vue